import React from 'react';
import { Section } from './ui/Section';
import { MonitorPlayIcon, SearchIcon, GraduationCapIcon } from 'lucide-react';
export function FailedSolutions() {
  return <Section data-id="element-31">
      <div className="text-center mb-16" data-id="element-32">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-33">
          Lo que intentaste (y por qué no funcionó)
        </h2>
        <p className="text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-34">
          No te faltan ganas. Te falta un sistema pequeño que funcione en días
          normales: con prisa, con ansiedad y con poco tiempo.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-35">
        {[{
        icon: MonitorPlayIcon,
        title: 'Videos sueltos',
        desc: 'Te emocionas 10 minutos y después no sabes cómo aplicarlo a tu caso real.'
      }, {
        icon: SearchIcon,
        title: 'Prompts de internet',
        desc: "Sirven 'más o menos', pero no encajan con tu negocio, tu cliente, ni tu tono."
      }, {
        icon: GraduationCapIcon,
        title: 'Cursos largos',
        desc: "Te prometen 'dominar IA', pero tú solo querías contestar mensajes y vender esta semana."
      }].map((item, i) => <div key={i} className="bg-stone-50 p-8 rounded-2xl border border-stone-100 hover:border-amber-200 transition-colors" data-id="element-36">
            <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center mb-6 text-amber-700" data-id="element-37">
              <item.icon className="h-6 w-6" data-id="element-38" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-39">
              {item.title}
            </h3>
            <p className="text-stone-600 leading-relaxed" data-id="element-40">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}